/* MyMagicMemory Wandkunst-Kaufbox v10 - Quelle: wandkunst_kaufbox/kaufbox_v10.py */
(function(){
var D = JSON.parse(document.querySelector('[data-pdp-daten]').textContent);
var B = D.bausteine || {};
D.rahmenbilder = B.rahmen || {};
D.oeffnung = (B.rahmen && B.rahmen.schwarz && B.rahmen.schwarz.oeffnung)
  || { x:0.1121, y:0.0546, w:0.7758, h:0.8912 };
D.motive = D.motive || [];
if(D.produkt.motiv && !D.motive.some(function(m){ return m.handle === D.produkt.handle; }))
  D.motive.unshift(D.produkt.motiv);
if(!D.produkt.bilder.length || !D.motive.length) return;

function bildUrl(u, breite){
  return /^https?:/i.test(u || '') || /^\/\//.test(u || '')
    ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite : (u || '');
}
function setzeMotivBild(behaelter, motiv){
  behaelter.innerHTML = '';
  var f = motiv.flach, img = document.createElement('img');
  img.alt = motiv.titel; img.loading = 'lazy';
  if(f && f.url){
    img.src = bildUrl(f.url, 700);
    img.style.position = 'absolute';
    img.style.width = (100 / f.w) + '%';
    img.style.height = 'auto';
    img.style.maxWidth = 'none';
    img.style.objectFit = 'unset';
    img.style.marginLeft = (-100 * f.x / f.w) + '%';
    img.style.marginTop = (-100 * f.y / f.w) + '%';
  } else {
    img.src = bildUrl(motiv.bild, 500);
    img.style.width = '100%'; img.style.height = '100%'; img.style.objectFit = 'cover';
  }
  behaelter.appendChild(img);
}
/* Rahmenmaße seit v10; die A-Namen nur als Rückfall für nicht umgestellte Produkte. */
var FOLGE = ['13x18','21x30','30x40','50x70','70x100','100x140','A4','A3','A2','A1','A0'];
var MM = { '13x18':[130,180], '21x30':[210,300], '30x40':[300,400], '50x70':[500,700],
           '70x100':[700,1000], '100x140':[1000,1400],
           A4:[210,297], A3:[297,420], A2:[420,594], A1:[594,841], A0:[841,1189] };
var GROESSEN = FOLGE;
/* Derselbe Rahmen, alte und neue Schreibweise */
var RAHMEN_ALIAS = { '21x30':'A4', '30x40':'A3', '50x70':'A2', '70x100':'A1',
                     A4:'21x30', A3:'30x40', A2:'50x70', A1:'70x100' };
var RAHMENWAHL = [['ohne','Ohne Rahmen'],['schwarz','Schwarz'],['weiss','Weiß']];
var FARBE = { schwarz:'Schwarz', weiss:'Weiß' };
var euro = new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'});
var zahlF = new Intl.NumberFormat('de-DE',{maximumFractionDigits:1});
var geld = function(c){ return euro.format(c/100); };
var cm = function(mm){ return zahlF.format(mm/10); };
/* „30 × 40 cm“ – bei alten A-Namen „A3 · 29,7 × 42 cm“ */
function groesseText(g){
  var m = MM[g];
  if(!m) return g;
  var mass = cm(m[0]) + ' × ' + cm(m[1]) + ' cm';
  return /^A\d$/.test(g) ? g + ' · ' + mass : mass;
}
var nach = {}; D.motive.forEach(function(m){ nach[m.handle] = m; });

var PAKETE = [1, 3, 6, 9];
var stand = { paket:1, motive:[], groesse:'A3', rahmen:'ohne', bild:0 };
if(nach[D.produkt.handle] && nach[D.produkt.handle].groessen['30x40']) stand.groesse = '30x40';
/* Kommt der Kunde ueber eine Anzeige, steht die beworbene Variante im Link
   (?variant=<id>). Dann gilt dieses Format - sonst sieht er einen anderen Preis
   als in der Anzeige. */
(function(){
  var id = null;
  try { id = new URLSearchParams(window.location.search).get('variant'); } catch(e){}
  var eigen = nach[D.produkt.handle];
  if(!id || !eigen) return;
  Object.keys(eigen.groessen).forEach(function(g){
    if(String(eigen.groessen[g].id) === String(id)) stand.groesse = g;
  });
})();
stand.motive.push({ h: D.produkt.handle, g: stand.groesse, r: stand.rahmen });
var filter = '';
var suchwort = '';

var q = function(s){ return document.querySelector(s); };
var el = {};
['galerie','grossbild','minis','waehler','fertig','band','filter','raster','titel','unter',
 'suche','suchleeren',
 'streifen','sreiter','sreihe','schritt2',
 'bewertung','sterne','bewertungtext',
 'alt','neu','spar','packs','motivzahl','plaetze','groessen','rahmen','kaufen','tabelle',
 'lupe','lupezu','lupebild','packhinweis'].forEach(function(n){ el[n] = q('[data-' + n + ']'); });

/* Shopify verschenkt je 3 Bilder das guenstigste - die Seite rechnet genauso.
   Bei Gleichstand trifft es das hintere Bild. */
function platzPreis(i){
  var p = stand.motive[i];
  var g = p ? p.g : stand.groesse;
  var m = p ? nach[p.h] : null;
  if(m && m.groessen[g]) return m.groessen[g].preis;
  var e = nach[D.produkt.handle].groessen[g];
  return e ? e.preis : 0;
}
function gratisPlaetze(){
  var idx = [];
  for(var i = 0; i < stand.paket; i++) idx.push(i);
  idx.sort(function(a, b){ return platzPreis(a) - platzPreis(b) || b - a; });
  return idx.slice(0, Math.floor(stand.paket / 3));
}
function istGratis(i){ return gratisPlaetze().indexOf(i) > -1; }
function rahmenVar(g, r){
  g = g || stand.groesse;
  var farbe = FARBE[r || stand.rahmen];
  return D.rahmen[g + '|' + farbe]
      || (RAHMEN_ALIAS[g] ? D.rahmen[RAHMEN_ALIAS[g] + '|' + farbe] : null)
      || null;
}
/* Jeder Platz traegt sein eigenes Format und seinen eigenen Rahmen. */
function neuerPlatz(h){ return { h: h, g: stand.groesse, r: stand.rahmen }; }
function platzNr(h){
  for(var i = 0; i < stand.motive.length; i++){
    if(stand.motive[i] && stand.motive[i].h === h) return i;
  }
  return -1;
}
function gueltig(p){
  var m = nach[p.h];
  if(m && !m.groessen[p.g]) p.g = stand.groesse;
  if(p.r !== 'ohne' && !rahmenVar(p.g, p.r)) p.r = 'ohne';
  return p;
}

function rechne(){
  var roh = 0, zahlt = 0, r = 0;
  for(var i = 0; i < stand.paket; i++){
    var p = stand.motive[i];
    var g = p ? p.g : stand.groesse;
    var m = p ? nach[p.h] : null;
    var e = m && m.groessen[g] ? m.groessen[g].preis
          : nach[D.produkt.handle].groessen[g].preis;
    roh += e;
    if(!istGratis(i)) zahlt += e;
    var rf = p ? p.r : stand.rahmen;
    if(rf !== 'ohne'){
      var rv = rahmenVar(g, rf);
      if(rv) r += rv.preis;
    }
  }
  return { voll: roh + r, zahlt: zahlt + r, spar: roh - zahlt, rahmen: r };
}

/* ---------- Bilder ---------- */
function rahmenKnoten(m, farbe){
  var d = document.createElement('div');
  farbe = farbe || stand.rahmen;
  if(farbe === 'ohne'){
    d.className = 'rahmen rahmen--nackt';
    var i0 = document.createElement('div');
    i0.className = 'rahmen__innen';
    setzeMotivBild(i0, m); d.appendChild(i0);
    return d;
  }
  var rb = D.rahmenbilder[farbe], o = D.oeffnung;
  if(!rb || !rb.overlay){
    d.className = 'rahmen rahmen--nackt';
    var iA = document.createElement('div');
    iA.className = 'rahmen__innen';
    setzeMotivBild(iA, m); d.appendChild(iA);
    return d;
  }
  d.className = 'rahmen';
  var i = document.createElement('div');
  i.className = 'rahmen__innen';
  i.style.left = (o.x*100)+'%'; i.style.top = (o.y*100)+'%';
  i.style.width = (o.w*100)+'%'; i.style.height = (o.h*100)+'%';
  setzeMotivBild(i, m);
  var ov = document.createElement('img');
  ov.className = 'rahmen__over'; ov.src = bildUrl(rb.overlay, 700);
  ov.alt = ''; ov.loading = 'lazy';
  d.appendChild(i); d.appendChild(ov);
  return d;
}

function baueGalerie(){
  el.grossbild.src = bildUrl(D.produkt.bilder[stand.bild], 1100);
  el.grossbild.alt = D.produkt.titel;
  el.minis.innerHTML = '';
  D.produkt.bilder.forEach(function(b, i){
    var k = document.createElement('button');
    k.type = 'button';
    k.setAttribute('aria-pressed', String(i === stand.bild));
    var img = document.createElement('img');
    img.src = bildUrl(b, 260); img.alt = ''; img.loading = 'lazy';
    k.appendChild(img);
    k.addEventListener('click', function(){ stand.bild = i; baueGalerie(); });
    el.minis.appendChild(k);
  });
}

/* ---------- Motivauswahl ---------- */
function kategorien(){
  var k = (D.kategorien && D.kategorien.length) ? D.kategorien : null;
  if(k) return k.map(function(x){
    return { name: x.name, tag: 'stil-' + x.slug };
  });
  /* Rückfall, solange das Metafeld mmm.kategorien noch nicht gefüllt ist */
  var z = {};
  D.motive.forEach(function(m){
    m.tags.forEach(function(t){
      if(D.basisTags.indexOf(t) > -1 || t.indexOf('stil-') === 0) return;
      z[t] = (z[t] || 0) + 1;
    });
  });
  return Object.keys(z).filter(function(t){ return z[t] >= 3; })
    .sort(function(a,b){ return z[b] - z[a]; }).slice(0, 7)
    .map(function(t){ return { name: t, tag: t }; });
}

function passt(m){
  if(filter && m.tags.indexOf(filter) < 0) return false;
  if(!suchwort) return true;
  var heu = (m.titel + ' ' + m.tags.join(' ')).toLowerCase();
  return suchwort.split(/\s+/).every(function(w){ return heu.indexOf(w) > -1; });
}

function baueFilter(){
  var liste = kategorien();
  el.filter.innerHTML = '';
  [{ name: 'Alle Motive', tag: '' }].concat(liste).forEach(function(k){
    var n = D.motive.filter(function(m){
      return !k.tag || m.tags.indexOf(k.tag) > -1;
    }).length;
    if(k.tag && !n) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'pille';
    b.textContent = k.name;
    var z = document.createElement('span');
    z.className = 'pille__zahl'; z.textContent = n;
    b.appendChild(z);
    b.setAttribute('aria-pressed', String(k.tag === filter));
    b.addEventListener('click', function(){ filter = k.tag; baueFilter(); baueRaster(); });
    el.filter.appendChild(b);
  });
}

function baueRaster(){
  el.raster.innerHTML = '';
  var treffer = D.motive.filter(passt);
  if(!treffer.length){
    var leer = document.createElement('p');
    leer.className = 'kat__leer';
    leer.textContent = 'Kein Motiv gefunden. Versuch es mit einem anderen Wort '
      + 'oder wähle links eine Kategorie.';
    el.raster.appendChild(leer);
    return;
  }
  treffer.forEach(function(m){
      var k = document.createElement('article');
      k.className = 'karte';
      var b = document.createElement('div');
      b.className = 'karte__buehne';
      b.appendChild(rahmenKnoten(m));
      var t = document.createElement('p');
      t.className = 'karte__titel'; t.style.margin = '0'; t.textContent = m.titel;
      var u = document.createElement('p');
      u.className = 'karte__unter'; u.style.margin = '0';
      u.textContent = m.tags.filter(function(x){
          return D.basisTags.indexOf(x) < 0 && x.indexOf('stil-') !== 0; })
        .slice(0, 2).join(' · ');
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'karte__add';
      var i = platzNr(m.handle);
      var fest = m.handle === D.produkt.handle;
      var voll = stand.motive.length >= stand.paket;
      if(fest){ a.className += ' is-drin'; a.disabled = true; a.textContent = '✓ DEIN MOTIV'; }
      else if(i > -1){ a.className += ' is-drin'; a.textContent = '✓ IM SET'; }
      else if(voll){ a.disabled = true; a.textContent = 'SET IST VOLL'; }
      else { a.textContent = '+ HINZUFÜGEN'; }
      a.addEventListener('click', function(){
        if(fest) return;
        var j = platzNr(m.handle);
        if(j > -1) stand.motive.splice(j, 1);
        else if(stand.motive.length < stand.paket) stand.motive.push(neuerPlatz(m.handle));
        zeichne();
        if(stand.motive.length >= stand.paket) schliesseWaehler();
      });
      k.appendChild(b); k.appendChild(t); k.appendChild(u); k.appendChild(a);
      el.raster.appendChild(k);
    });
}

el.suche.addEventListener('input', function(){
  suchwort = el.suche.value.trim().toLowerCase();
  el.suchleeren.hidden = !suchwort;
  baueRaster();
});
el.suchleeren.addEventListener('click', function(){
  el.suche.value = ''; suchwort = ''; el.suchleeren.hidden = true;
  baueRaster(); el.suche.focus();
});

function oeffneWaehler(){
  if(stand.paket < 2) return;
  el.galerie.hidden = true;
  el.waehler.hidden = false;
  baueFilter(); baueRaster();
  /* Auf schmalen Schirmen steht die Auswahl oberhalb der Kaufbox. Vorher war
     das Scrollen gesperrt, dadurch blieben Kopfzeile, Suche und Filter
     ausserhalb des Bildes. Jetzt springt die Seite an den Anfang der Auswahl
     und bleibt scrollbar. */
  if(window.innerWidth <= 940){
    requestAnimationFrame(function(){
      var y = el.waehler.getBoundingClientRect().top + window.pageYOffset - 6;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
  }
}
function schliesseWaehler(){
  el.waehler.hidden = true;
  el.galerie.hidden = false;
  document.body.style.overflow = '';
}

/* Schnellzugriff: weitere Motive als Streifen mit Reitern, wie beim Wettbewerb.
   Ein Tipp hängt das Motiv an, ein zweiter nimmt es wieder ab. */
var sreiter = '';
function baueStreifen(){
  el.streifen.hidden = false;
  var einzeln = stand.paket < 2;

  /* Reiter aus denselben Kategorien wie die große Auswahl, damit
     beide Ansichten dieselbe Sprache sprechen. */
  var kats = kategorien().filter(function(k){
    return D.motive.some(function(m){ return m.tags.indexOf(k.tag) > -1; });
  }).slice(0, 6);

  el.sreiter.innerHTML = '';
  [['', einzeln ? 'Andere Motive' : 'Passt dazu']]
    .concat(kats.map(function(k){ return [k.tag, k.name]; }))
    .forEach(function(paar){
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = paar[1];
      b.setAttribute('aria-pressed', String(paar[0] === sreiter));
      b.addEventListener('click', function(){ sreiter = paar[0]; baueStreifen(); });
      el.sreiter.appendChild(b);
    });

  var eigene = nach[D.produkt.handle].tags.filter(function(t){
    return D.basisTags.indexOf(t) < 0; });
  var liste = D.motive.filter(function(m){
    if(m.handle === D.produkt.handle) return false;
    if(sreiter) return m.tags.indexOf(sreiter) > -1;
    return m.tags.some(function(t){ return eigene.indexOf(t) > -1; });
  });
  if(!liste.length) liste = D.motive.filter(function(m){ return m.handle !== D.produkt.handle; });

  el.sreihe.innerHTML = '';
  liste.slice(0, 20).forEach(function(m){
    var b = document.createElement('button');
    b.type = 'button';
    var drin = platzNr(m.handle) > -1;
    b.className = 'sw' + (drin ? ' is-drin' : '');
    b.title = m.titel;
    b.appendChild(rahmenKnoten(m));
    b.addEventListener('click', function(){
      if(einzeln){
        // Beim Einzelkauf führt der Streifen auf das jeweilige Poster.
        window.location.href = '/products/' + m.handle;
        return;
      }
      var i = platzNr(m.handle);
      if(i > -1) stand.motive.splice(i, 1);
      else if(stand.motive.length < stand.paket) stand.motive.push(neuerPlatz(m.handle));
      zeichne();
    });
    el.sreihe.appendChild(b);
  });
}

/* ---------- Kasten ---------- */
function bauePacks(){
  el.packs.innerHTML = '';
  PAKETE.forEach(function(n){
    var gratis = Math.floor(n / 3);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'pack';
    b.setAttribute('aria-pressed', String(n === stand.paket));
    b.textContent = n === 1 ? 'Einzeln' : (n - gratis) + ' Bilder';
    if(gratis){
      var o = document.createElement('span');
      o.className = 'pack__oben';
      o.textContent = Math.round(gratis / n * 100) + '% SPAREN';
      var u = document.createElement('span');
      u.className = 'pack__unten';
      u.textContent = '+' + gratis + ' GRATIS';
      b.appendChild(o); b.appendChild(u);
    }
    b.addEventListener('click', function(){
      stand.paket = n;
      if(stand.motive.length > n) stand.motive.length = n;
      zeichne();
      if(n > 1 && stand.motive.length < n) oeffneWaehler(); else schliesseWaehler();
    });
    el.packs.appendChild(b);
  });
}

function bauePlaetze(){
  el.plaetze.innerHTML = '';
  if(stand.paket === 1){
    el.plaetze.style.display = 'none';
    if(el.schritt2) el.schritt2.style.display = 'none';
    return;
  }
  el.plaetze.style.display = '';
  if(el.schritt2) el.schritt2.style.display = '';
  for(var i = 0; i < stand.paket; i++){
    (function(i){
      var pl = stand.motive[i] ? gueltig(stand.motive[i]) : null;
      var m = pl ? nach[pl.h] : null;
      var gratis = istGratis(i), fest = i === 0;
      var d = document.createElement('div');
      d.className = 'platz' + (gratis ? ' platz--gratis' : (fest ? ' platz--fest' : ''));
      if(gratis || fest){
        var tab = document.createElement('span');
        tab.className = 'platz__tab';
        tab.textContent = gratis ? 'GRATIS' : 'DEIN MOTIV';
        d.appendChild(tab);
      }
      if(m){
        var bild = document.createElement('div');
        bild.className = 'platz__bild';
        bild.appendChild(rahmenKnoten(m, pl.r));
        d.appendChild(bild);
        var t = document.createElement('div');
        t.className = 'platz__text';
        var t1 = document.createElement('div');
        t1.className = 'platz__titel'; t1.textContent = m.titel;
        var t2 = document.createElement('div');
        t2.className = 'platz__wahl';

        /* Format je Bild */
        var wg = document.createElement('select');
        wg.setAttribute('aria-label', 'Format für ' + m.titel);
        GROESSEN.forEach(function(g){
          if(!m.groessen[g]) return;
          var o = document.createElement('option');
          o.value = g;
          o.textContent = groesseText(g);
          if(g === pl.g) o.selected = true;
          wg.appendChild(o);
        });
        wg.addEventListener('change', function(){ pl.g = wg.value; zeichne(); });

        /* Rahmen je Bild */
        var wr = document.createElement('select');
        wr.setAttribute('aria-label', 'Rahmen für ' + m.titel);
        RAHMENWAHL.forEach(function(f){
          var rv = f[0] === 'ohne' ? null : rahmenVar(pl.g, f[0]);
          if(f[0] !== 'ohne' && !rv) return;
          var o = document.createElement('option');
          o.value = f[0];
          o.textContent = rv ? f[1] + ' +' + geld(rv.preis) : f[1];
          if(f[0] === pl.r) o.selected = true;
          wr.appendChild(o);
        });
        wr.addEventListener('change', function(){ pl.r = wr.value; zeichne(); });

        t2.appendChild(wg); t2.appendChild(wr);
        t.appendChild(t1); t.appendChild(t2);
        d.appendChild(t);
        var p = document.createElement('div');
        p.className = 'platz__preis';
        var e = m.groessen[pl.g] ? m.groessen[pl.g].preis : 0;
        if(gratis){
          var del = document.createElement('del'); del.textContent = geld(e);
          p.appendChild(del); p.appendChild(document.createTextNode('0,00 €'));
        } else { p.textContent = geld(e); }
        d.appendChild(p);
        if(!fest){
          var weg = document.createElement('button');
          weg.type = 'button'; weg.className = 'platz__weg';
          weg.setAttribute('aria-label','Entfernen'); weg.textContent = '×';
          weg.addEventListener('click', function(){ stand.motive.splice(i,1); zeichne(); });
          d.appendChild(weg);
        }
      } else {
        var leer = document.createElement('div');
        leer.className = 'platz__leer';
        var t3 = document.createElement('div');
        t3.className = 'platz__text';
        var t4 = document.createElement('div');
        t4.className = 'platz__titel';
        t4.textContent = gratis ? 'Freier Platz — geschenkt' : 'Leerer Platz';
        var t5 = document.createElement('div');
        t5.className = 'platz__hinweis';
        t5.textContent = gratis ? 'Dieses Motiv kostet dich nichts.' : 'Motiv aussuchen';
        t3.appendChild(t4); t3.appendChild(t5);
        d.appendChild(leer); d.appendChild(t3);
        d.style.cursor = 'pointer';
        d.addEventListener('click', oeffneWaehler);
      }
      el.plaetze.appendChild(d);
    })(i);
  }
}

function baueWahl(){
  el.groessen.innerHTML = '';
  var m0 = nach[D.produkt.handle];
  FOLGE.forEach(function(g){
    if(!m0.groessen[g]) return;
    var o = document.createElement('option');
    o.value = g;
    o.textContent = groesseText(g) + '  ·  ' + geld(m0.groessen[g].preis)
      + (rahmenVar(g, 'schwarz') || rahmenVar(g, 'weiss') ? '' : '  ·  nur ohne Rahmen');
    if(g === stand.groesse) o.selected = true;
    el.groessen.appendChild(o);
  });

  el.rahmen.innerHTML = '';
  RAHMENWAHL.forEach(function(f){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'rk';
    b.setAttribute('aria-pressed', String(f[0] === stand.rahmen));
    if(f[0] === 'ohne'){
      var mk = document.createElement('span');
      mk.className = 'beliebt'; mk.textContent = 'BELIEBT';
      var le = document.createElement('span'); le.className = 'rk__leer';
      b.appendChild(mk); b.appendChild(le);
    } else {
      var rb = D.rahmenbilder[f[0]];
      if(rb && rb.kachel){
        var img = document.createElement('img');
        img.className = 'rk__bild'; img.src = bildUrl(rb.kachel, 320);
        img.alt = 'Rahmen ' + f[1]; img.loading = 'lazy';
        b.appendChild(img);
      } else {
        var ers = document.createElement('span');
        ers.className = 'rk__leer';
        ers.style.background = f[0] === 'schwarz'
          ? 'linear-gradient(160deg,#33302C,#141311)'
          : 'linear-gradient(160deg,#FFFFFF,#E6E3DE)';
        b.appendChild(ers);
      }
      b.disabled = !rahmenVar(stand.groesse, f[0]);
    }
    var nm = document.createElement('span');
    nm.className = 'rk__name'; nm.textContent = f[1];
    var pr = document.createElement('span');
    pr.className = 'rk__preis';
    if(f[0] === 'ohne'){ pr.textContent = 'nur der Druck'; }
    else {
      var rv = rahmenVar(stand.groesse, f[0]);
      pr.textContent = rv ? '+' + geld(rv.preis) + ' je Bild' : 'nicht in ' + groesseText(stand.groesse);
    }
    b.appendChild(nm); b.appendChild(pr);
    b.addEventListener('click', function(){
      if(b.disabled) return;
      stand.rahmen = f[0];
      stand.motive.forEach(function(pl){ pl.r = stand.rahmen; gueltig(pl); });
      zeichne();
    });
    el.rahmen.appendChild(b);
  });
}

/* Loox pflegt Schnitt und Anzahl selbst im Shop-Metafeld, Form "4.8,6246". */
function baueBewertung(){
  var roh = (D.loox || '').split(',');
  var schnitt = parseFloat(roh[0]), anzahl = parseInt(roh[1], 10);
  if(!schnitt || !anzahl){ el.bewertung.hidden = true; return; }
  el.bewertung.hidden = false;
  var voll = Math.floor(schnitt + 0.25);
  var stern = '\u2605', leer = '\u2606';
  el.sterne.textContent = stern.repeat(voll) + leer.repeat(5 - voll);
  el.bewertungtext.textContent = 'Shop-Bewertung '
    + schnitt.toLocaleString('de-DE', { minimumFractionDigits: 1 })
    + ' · ' + anzahl.toLocaleString('de-DE') + ' Bewertungen';
}

function baueKopf(){
  var r = rechne();
  el.titel.textContent = D.produkt.titel;
  el.unter.textContent = D.produkt.unter;
  baueBewertung();
  el.alt.textContent = geld(r.voll);
  el.neu.textContent = geld(r.zahlt);
  el.spar.textContent = r.spar > 0 ? 'SPARE ' + geld(r.spar) : '';
  el.spar.style.display = r.spar > 0 ? '' : 'none';
  el.alt.style.display = r.spar > 0 ? '' : 'none';
  if(el.packhinweis) el.packhinweis.hidden = stand.paket === 1;
  el.motivzahl.textContent = stand.paket === 1 ? ''
    : stand.motive.length + ' von ' + stand.paket + ' gewählt';
  el.band.textContent = 'Noch ' + Math.max(0, stand.paket - stand.motive.length)
    + ' Motive wählen — jedes dritte Bild ist geschenkt';

  var fehlt = stand.paket - stand.motive.length;
  if(fehlt > 0){
    el.kaufen.className = 'kaufen is-aus';
    el.kaufen.textContent = fehlt === 1 ? 'NOCH EIN MOTIV WÄHLEN'
      : 'NOCH ' + fehlt + ' MOTIVE WÄHLEN';
  } else {
    el.kaufen.className = 'kaufen';
    el.kaufen.textContent = 'IN DEN WARENKORB · ' + geld(r.zahlt);
  }
}

/* Nummern der sichtbaren Schritte fortlaufend - im Einzelkauf faellt Schritt 2 weg */
function nummeriere(){
  var nr = 0;
  Array.prototype.forEach.call(document.querySelectorAll('.kauf__rollen .schritt'), function(sch){
    if(sch.offsetParent === null && getComputedStyle(sch).display === 'none') return;
    if(sch.style.display === 'none') return;
    var i = sch.querySelector('i'); if(i) i.textContent = ++nr;
  });
}
function zeichne(){
  bauePacks(); baueStreifen(); bauePlaetze(); baueWahl(); baueKopf(); baueGalerie(); nummeriere();
  if(!el.waehler.hidden) baueRaster();
}

el.fertig.addEventListener('click', schliesseWaehler);
el.groessen.addEventListener('change', function(){
  stand.groesse = el.groessen.value;
  if(stand.rahmen !== 'ohne' && !rahmenVar()) stand.rahmen = 'ohne';
  /* Die obere Wahl ist die Voreinstellung und setzt alle Plaetze mit. */
  stand.motive.forEach(function(pl){ pl.g = stand.groesse; gueltig(pl); });
  zeichne();
});
el.tabelle.addEventListener('click', function(){
  el.lupebild.src = bildUrl(D.groessentabelle, 1200); el.lupe.hidden = false;
});
el.lupezu.addEventListener('click', function(){ el.lupe.hidden = true; });
el.lupe.addEventListener('click', function(e){ if(e.target === el.lupe) el.lupe.hidden = true; });
document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ el.lupe.hidden = true; } });
el.kaufen.addEventListener('click', function(){
  if(stand.motive.length < stand.paket){ oeffneWaehler(); return; }
  var posten = [];
  stand.motive.forEach(function(pl){
    var m = nach[pl.h];
    if(!m || !m.groessen[pl.g]) return;
    posten.push({ id: m.groessen[pl.g].id, quantity: 1 });
    if(pl.r !== 'ohne'){
      var rv = rahmenVar(pl.g, pl.r);
      if(rv) posten.push({ id: rv.id, quantity: 1, properties: { _mmm_zu: String(posten[posten.length - 1].id), _mmm_upsell: 'rahmen', _mmm_quelle: 'kaufbox' } });
    }
  });
  if(!posten.length) return;
  var vorher = el.kaufen.textContent;
  el.kaufen.disabled = true; el.kaufen.textContent = 'WIRD HINZUGEFÜGT …';
  fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ items: posten }) })
    .then(function(r){ if(!r.ok) throw new Error('cart'); if(window.mmmWarenkorbBereit){ el.kaufen.disabled = false; el.kaufen.textContent = vorher; document.dispatchEvent(new CustomEvent('mmm:warenkorb:oeffnen')); } else { window.location.href = '/cart'; } })
    .catch(function(){ el.kaufen.disabled = false; el.kaufen.textContent = vorher; });
});

zeichne();

/* Der Abschnitt richtet sich nach seiner eigenen Breite, nicht nach der des
   Fensters. So sitzt er auch dann richtig, wenn er in einer Spalte steckt. */
var huelle = q('[data-wrap]');

/* Das Theme legt seine Blöcke mit einer Einblendung an und lässt sie bis dahin
   unsichtbar. Unser Block wird dadurch nie sichtbar, weil die Einblendung nicht
   ausgelöst wird. Außerdem behält die Spalte ihre schmale Breite, obwohl die
   Galerie daneben ausgeblendet ist. Beides ziehen wir hier gerade. */
function befreieBlock(){
  if(!huelle) return;
  var block = huelle.closest('.product-single__box__block');
  if(block){
    block.style.opacity = '1';
    block.style.transform = 'none';
    block.style.width = '100%';
    block.style.maxWidth = 'none';
  }
  ['.product-single__box', '.product-single__primary-blocks'].forEach(function(sel){
    var e = huelle.closest(sel);
    if(e){ e.style.width = '100%'; e.style.maxWidth = 'none'; }
  });
  /* Das Theme legt diese Spalte absolut über den Rest. Dadurch landete die
     Beschreibung im Bild statt darunter. Zurück in den normalen Fluss. */
  var spalte = huelle.closest('.product-single__primary-blocks');
  if(spalte) spalte.style.position = 'static';
}
befreieBlock();
setTimeout(befreieBlock, 400);
setTimeout(befreieBlock, 1600);

function messe(){ if(huelle) huelle.classList.toggle('ist-schmal', huelle.clientWidth < 900); }
messe();
if(window.ResizeObserver && huelle) new ResizeObserver(messe).observe(huelle);
window.addEventListener('resize', messe);
})();
